


<form [formGroup]="criteriaForm" class="criteria-form" (ngSubmit)="onSubmit()">
    @switch (bookType) {
      @case ('SKFRDriver') {
          <mat-form-field appearance="fill">
            <mat-label>{{'PhoneNr' | translate}}</mat-label>
            <input matInput formControlName="customerIdentifier" placeholder="Enter the phone no...">
            <button matSuffix mat-icon-button aria-label="Clear" (click)="clearField('customerIdentifier')">
              <mat-icon>close</mat-icon>
            </button>
            @if (criteriaForm.controls['customerIdentifier'].hasError('minlength') && !criteriaForm.controls['customerIdentifier'].hasError('required')) {
              <mat-error>
                {{'FieldRequiredMoreThanFiveChar' | translate}}
              </mat-error>
            }
            @if (criteriaForm.controls['customerIdentifier'].hasError('required')) {
              <mat-error [innerHtml]="'FieldRequired' | translate">
              </mat-error>
            }
          </mat-form-field>
      }
      @case ('KBW') {
          <mat-form-field appearance="fill">
            <mat-label>{{'FirstName' | translate }}</mat-label>
            <input matInput formControlName="firstName" [errorStateMatcher]="matcher" placeholder="Wprowadź imię...">
            <button matSuffix mat-icon-button aria-label="Clear" (click)="clearField('firstName')">
              <mat-icon>close</mat-icon>
            </button>
            @if (criteriaForm.controls['firstName'].hasError('minlength') && !criteriaForm.controls['firstName'].hasError('required')) {
              <mat-error>
                {{'FieldRequiredMoreThanTwoChar' | translate }}
              </mat-error>
            }
            @if (criteriaForm.controls['firstName'].hasError('required')) {
              <mat-error [innerHtml]="'FieldRequired' | translate">
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>{{'LastName' | translate }}</mat-label>
            <input matInput formControlName="lastName" placeholder="Wprowadź nazwisko...">
            <button matSuffix mat-icon-button aria-label="Clear" (click)="clearField('lastName')">
              <mat-icon>close</mat-icon>
            </button>
            @if (criteriaForm.controls['lastName'].hasError('minlength') && !criteriaForm.controls['lastName'].hasError('required')) {
              <mat-error>
                {{'FieldRequiredMoreThanTwoChar' | translate }}
              </mat-error>
            }
            @if (criteriaForm.controls['lastName'].hasError('required')) {
              <mat-error [innerHtml]="'FieldRequired' | translate">
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>{{'BirthDate' | translate }}</mat-label>
            <input matInput   formControlName="customerIdentifier" type="text" (click)="picker.open()" [matDatepicker]="picker" [min]="minDate" [max]="maxDate" placeholder="Wybierz datę z kalendarza..." >
            <button matSuffix mat-icon-button aria-label="Clear" (click)="clearField('customerIdentifier')">
              <mat-icon>close</mat-icon>
            </button>
            @if (criteriaForm.controls['customerIdentifier'].hasError('minlength') && !criteriaForm.controls['customerIdentifier'].hasError('required')) {
              <mat-error>
                {{'FieldRequiredMoreThanTwoChar' | translate }}
              </mat-error>
            }
            @if (criteriaForm.controls['customerIdentifier'].hasError('required')) {
              <mat-error [innerHtml]="'FieldRequired' | translate">
              </mat-error>
            }
            <mat-datepicker touchUi #picker startView="multi-year" disabled="false"></mat-datepicker>
          </mat-form-field>
      }
      @case ('KBK') {
          <mat-form-field appearance="fill">
            <mat-label>{{'FirstName' | translate }}</mat-label>
            <input matInput formControlName="firstName" [errorStateMatcher]="matcher" placeholder="Wprowadź imię...">
            <button matSuffix mat-icon-button aria-label="Clear" (click)="clearField('firstName')">
              <mat-icon>close</mat-icon>
            </button>
            @if (criteriaForm.controls['firstName'].hasError('minlength') && !criteriaForm.controls['firstName'].hasError('required')) {
              <mat-error>
                {{'FieldRequiredMoreThanTwoChar' | translate }}
              </mat-error>
            }
            @if (criteriaForm.controls['firstName'].hasError('required')) {
              <mat-error [innerHtml]="'FieldRequired' | translate">
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>{{'LastName' | translate }}</mat-label>
            <input matInput formControlName="lastName" placeholder="Wprowadź nazwisko...">
            <button matSuffix mat-icon-button aria-label="Clear" (click)="clearField('lastName')">
              <mat-icon>close</mat-icon>
            </button>
            @if (criteriaForm.controls['lastName'].hasError('minlength') && !criteriaForm.controls['lastName'].hasError('required')) {
              <mat-error>
                {{'FieldRequiredMoreThanTwoChar' | translate }}
              </mat-error>
            }
            @if (criteriaForm.controls['lastName'].hasError('required')) {
              <mat-error [innerHtml]="'FieldRequired' | translate">
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>{{'DocumentNr' | translate }}</mat-label>
            <input matInput formControlName="documentNr" placeholder="Wprowadź nr dokumentu...">
            <button matSuffix mat-icon-button aria-label="Clear" (click)="clearField('documentNr')">
              <mat-icon>close</mat-icon>
            </button>
            @if (criteriaForm.controls['documentNr'].hasError('minlength') && !criteriaForm.controls['documentNr'].hasError('required')) {
              <mat-error>
                {{'FieldRequiredMoreThanTwoChar' | translate }}
              </mat-error>
            }
            @if (criteriaForm.controls['documentNr'].hasError('required')) {
              <mat-error [innerHtml]="'FieldRequired' | translate">
              </mat-error>
            }
          </mat-form-field>
      }
      @default {
        <p>Not found</p>
      }
    }


  <div class="form-btn-wrapper">
    <button mat-raised-button color="primary" type="submit" [disabled]="!criteriaForm.valid">
      @if (loading) {
        <span class="spinner-border spinner-border-sm mr-1"></span>
      }
      {{'Find' | translate }}
    </button>
  </div>
</form>